import { createFileRoute, Outlet, Link as RouterLink } from "@tanstack/react-router"

import { Footer } from "@/brand/components/footer"
import { Header } from "@/brand/components/header"
import { Logo } from "@/brand/components/logo"
import config from "@/config"
import { Button } from "@/ui/button"

import { GithubIcon, TwitterIcon } from "../components/social"

export const Route = createFileRoute("/_brand-layout")({
  component: ContentLayout,
})

function ContentLayout() {
  return (
    <>
      <Header
        position="absolute"
        logo={
          <a href="/" className="flex items-center gap-2 text-lg font-bold">
            <Logo className="size-9" />
            {config.core.projectName}
          </a>
        }
      >
        <Button variant="ghost" asChild>
          <a href="/#about">About</a>
        </Button>
        <Button variant="ghost" asChild>
          <a href="/#learn" aria-label="Learn (coming soon)">
            Learn
            <span
              className="inline-block size-2 animate-pulse rounded-full bg-amber-500"
              aria-hidden
            />
          </a>
        </Button>
        <Button variant="ghost" asChild>
          <RouterLink to="/blog">Blog</RouterLink>
        </Button>
        <Button variant="ghost" asChild>
          <a href="https://docs.pagezero.dev">Docs</a>
        </Button>
        <Button variant="ghost" asChild size="icon">
          <a href="https://github.com/pagezero-dev/pagezero" target="_blank" rel="noreferrer">
            <GithubIcon className="size-6" />
          </a>
        </Button>
        <Button variant="ghost" asChild size="icon">
          <a href="https://x.com/pawelgalazka" target="_blank" rel="noreferrer">
            <TwitterIcon className="size-6" />
          </a>
        </Button>
      </Header>

      <main>
        <Outlet />
      </main>

      <Footer
        companyName={config.core.projectName}
        navigation={[
          {
            heading: "Product",
            children: [
              {
                label: "Documentation",
                href: "https://docs.pagezero.dev",
              },
              {
                label: "Getting Started",
                href: "https://docs.pagezero.dev/getting-started/quick-start",
              },
            ],
          },
          {
            heading: "About",
            children: [
              { label: "Author", href: "/#about" },
              { label: "FAQ", href: "/#faq" },
            ],
          },
          {
            heading: "Support",
            children: [
              {
                label: "GitHub Issues",
                href: "https://github.com/pagezero-dev/pagezero/issues",
              },
            ],
          },
          {
            heading: "Legal",
            children: [
              { label: "Privacy", href: "/legal/privacy" },
              {
                label: "Terms and Conditions",
                href: "/legal/terms-and-conditions",
              },
              { label: "Licenses", href: "/legal/licenses" },
            ],
          },
        ]}
        socialMediaUrls={{
          twitterUrl: "https://x.com/pawelgalazka/",
          githubUrl: "https://github.com/pagezero-dev/pagezero",
        }}
      />
    </>
  )
}
